import "./App.css";
import {
  CircularProgress,
  Accordion,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import React, { useEffect, useState } from "react";
import axios from "axios";
import GameItem from "./components/GameItem";

class League {
  constructor(leagueId, marketId) {
    this.leagueId = leagueId;
    this.marketId = marketId;
  }
}

export function encodingFromSpanish(brokenString) {
  // Step 1: Convert the broken string (misinterpreted as ISO-8859-1) into a byte array.
  const byteArray = new Uint8Array(brokenString.length);

  for (let i = 0; i < brokenString.length; i++) {
    byteArray[i] = brokenString.charCodeAt(i);
  }

  // Step 2: Use TextDecoder to decode the byte array correctly as UTF-8
  const decoder = new TextDecoder("utf-8");
  const fixedString = decoder.decode(byteArray);
  return fixedString;
}

function importImages(r) {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}

function App() {
  const [sportName, setSportName] = useState([]);
  const [LeagueName, setLeaugeName] = useState([]);

  const urlParams = window.location.search.substring(1);
  const leagueRegex = /(?:leagueId=(\d+)\+marketId=(\w+))/g;
  const [expanded, setExpanded] = useState("panel1");
  const handleChange = (panel) => (isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const importedIcons = importImages(
    require.context("./assets", false, /\.(png)$/)
  );

  const headerBanner = "https://coderetech.com/blog-widget-assets/mexico.jpg";
  const iconHandler = (sportName) => {
    const cases = [
      { keyword: "Fútbol", icon: "football" },
      { keyword: "MMA", icon: "ufc" },
      { keyword: "Baloncesto", icon: "basketball" },
      { keyword: "Tenis", icon: "tennis" },
      { keyword: "American Football", icon: "nfl" },
      { keyword: "Béisbol", icon: "baseball" },
      { keyword: "eSports", icon: "e-sport" },
    ];

    for (const { keyword, icon } of cases) {
      if (sportName.includes(keyword)) {
        return icon;
      }
    }

    return cases[0].icon;
  };

  // const leagueList = [
  //   { leagueId: "2903511051", marketId: "1" }, // futbol - Primera División - 1x2
  //   { leagueId: "2817453712", marketId: "1" }, // futbol - UEFA, Champions League - 1x2
  //   { leagueId: "2817453708", marketId: "1" }, // futbol - Premier League - 1x2
  //   { leagueId: "3069005120", marketId: "1" }, // futbol - Primera A Colombia - 1x2
  //   { leagueId: "3361963058", marketId: "1" }, // futbol - Copa Libertadores - 1x2

  //   { leagueId: "3381766890", marketId: "97" }, // basketball - nba - ganador
  //   { leagueId: "3381766890", marketId: "159" }, // basketball - nba - handicap

  //   { leagueId: "3697988354", marketId: "97" }, // tennis - ATP Monte-Carlo - ganador

  //   { leagueId: "2819844675", marketId: "97" }, // mma - ufc - ganador

  //   { leagueId: "2819833171", marketId: "97" }, // beisbol - MLB - ganador

  // ];

  const [leagueList, setLeaugeList] = useState([]);
  const [games, setGames] = useState([]);
  const [odds, setOdds] = useState([]);

  // useEffect(() => {
  //   console.log(">>>");
  //   console.log(leagueList);
  // }, [leagueList]);

  useEffect(() => {
    if (!urlParams)
      setLeaugeList([
        new League("45349", "MRES"),
        new League("19161", "MRES"),
        new League("45346", "MRES"),
      ]);
    else {
      const pairs = [];
      let match;

      while ((match = leagueRegex.exec(urlParams)) !== null) {
        const leagueId = match[1];
        const marketId = match[2];
        pairs.push({ leagueId, marketId });
      }

      console.log(pairs);

      setLeaugeList([...pairs]);
    }
  }, []);

  const URL = process.env.REACT_APP_SERVER;

  const headers = {
    CodereAffiliateApiKey: process.env.REACT_APP_KEY,
    CodereAffiliateApiSecret: process.env.REACT_APP_SECRET,
  };

  useEffect(() => {
    const fetchGames = async () => {
      const promises = leagueList.map((league) => {
        const url = URL.replace("<leagueid>", league.leagueId).replace(
          "<marketid>",
          league.marketId
        );
        // console.log(url);
        return axios.get(url, { headers });
      });

      try {
        const responses = await Promise.all(promises);

        // console.log(responses);

        const updatedGames = responses.flatMap((res) => {
          // console.log("res >>");
          console.log(res.data.ContentAPI.Sport[0]);
          let data = res.data.ContentAPI.Sport[0];
          setSportName((prev) => [...prev, data["@name"]]);
          setLeaugeName((prev) => [
            ...prev,
            data.SBClass[0].SBType[0]["@name"],
          ]);

          return [
            res.data.ContentAPI.Sport[0].SBClass[0].SBType[0].Ev.sort(
              (a, b) => new Date(a["@start_time"]) - new Date(b["@start_time"])
            ),
          ];
        });

        // console.log(updatedGames);

        updatedGames.forEach((updatedGame, i) => {
          let tempOdds = updatedGames.flatMap((updatedGame) => [
            updatedGame.flatMap((game) => {
              // console.log(game);
              return [game.Mkt[0].Seln.map((odd) => odd.Price[0]["@us_prc"])];
            }),
          ]);

          setOdds([...tempOdds]);
        });

        // console.log(updatedGames);

        if (updatedGames.length) setGames([...updatedGames]);

        // setLeaugeList([new League("2903511051", "1")]);
      } catch (error) {
        console.log(error);
        // console.log("error avner");
        setLeaugeList([new League("45346", "MRES")]);
      }
    };

    fetchGames();
    // return () => {
    //   setLeaugeList([new League("45349", "MRES")]);
    // };
  }, [leagueList]);

  return (
    <div className="App">
      <div className="widget-wrapper">
        <a href="https://apuestas.codere.mx/es_MX" target="_blank">
          <img className="banner" width="430" height="430" src={headerBanner} />
        </a>
        <a
          className="tyc"
          target="_blank"
          href="https://www.codere.mx/promociones/welcome-bonus-hasta-5000-fd"
        >
          <span>Términos y Condiciones</span>
        </a>

        {!games.length ? (
          <CircularProgress
            style={{ color: "#fff", margin: "1rem auto", display: "flex" }}
          />
        ) : (
          <>
            {games.map((branch, i) => (
              <Accordion
                key={i}
                className="acc"
                expanded={expanded === `panel${i + 1}`}
                onChange={handleChange(
                  expanded === `panel${i + 1}` ? "false" : `panel${i + 1}`
                )}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  aria-controls={`panel${i + 1}bh-content`}
                  id={`panel${i + 1}bh-header`}
                >
                  <Typography
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      flexShrink: 0,
                      fontWeight: 700,
                    }}
                  >
                    <img
                      alt="icon"
                      style={{ marginRight: "15px" }}
                      width={20}
                      height={20}
                      src={importedIcons[`${iconHandler(sportName[i])}.png`]}
                    />
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span>
                        {sportName[i]} - {encodingFromSpanish(LeagueName[i])}
                      </span>
                      <span style={{ fontSize: "0.75rem" }}>
                        {/* {branch[0].Games[0].Name} */}
                      </span>
                    </span>
                  </Typography>
                </AccordionSummary>
                <GameItem branch={branch} odds={odds} i={i} />
              </Accordion>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

export default App;
